import createIcon from '../../createIcon';

/**
 * @component @name KeyOff
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTYuOTEgMTMuMzg1TDE3IDEzLjI5NUwxOSAxNS4yOTVMMjMgMTEuMjU1TDIxIDkuMjk0OThIMTIuODNMMTYuOTEgMTMuMzg1Wk0zLjk4IDYuMTA0OThDMi4yIDcuMTQ0OTggMSA5LjA4NDk4IDEgMTEuMjk1QzEgMTQuNjA1IDMuNjkgMTcuMjk1IDcgMTcuMjk1QzkuMjEgMTcuMjk1IDExLjE1IDE2LjA5NSAxMi4xOCAxNC4zMDVMMTkuNzcgMjEuODk1TDIxLjE4IDIwLjQ4NUwyLjgxIDIuMTA0OThMMS4zOSAzLjUxNDk4TDMuOTggNi4xMDQ5OFpNOS45MSAxMi4wMzVDOS41OCAxMy4zMjUgOC40IDE0LjI5NSA3IDE0LjI5NUM1LjM1IDE0LjI5NSA0IDEyLjk0NSA0IDExLjI5NUM0IDkuODk0OTggNC45NyA4LjcxNDk4IDYuMjYgOC4zODQ5OEw5LjkxIDEyLjAzNVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const KeyOff = createIcon('KeyOff', [
  [
    'path',
    {
      d: 'M16.91 13.385L17 13.295L19 15.295L23 11.255L21 9.29498H12.83L16.91 13.385ZM3.98 6.10498C2.2 7.14498 1 9.08498 1 11.295C1 14.605 3.69 17.295 7 17.295C9.21 17.295 11.15 16.095 12.18 14.305L19.77 21.895L21.18 20.485L2.81 2.10498L1.39 3.51498L3.98 6.10498ZM9.91 12.035C9.58 13.325 8.4 14.295 7 14.295C5.35 14.295 4 12.945 4 11.295C4 9.89498 4.97 8.71498 6.26 8.38498L9.91 12.035Z',
      key: '1b6ws5',
    },
  ],
]);

export default KeyOff;
